import { ICharacter, ICharacterFilter, ISelectedCharacterFilter } from '@/types/aiWriting'
import { useState } from 'react'

const useAICharacterModel = () => {
  const [showcharacterSetting, setShowCharacterSetting] = useState(true) // 人设是否开启, 关闭后会清空人设
  const [characterList, setCharacterList] = useState<ICharacter[]>([]) // 人设列表
  const [aiRecommendCharacter, setAiRecommendCharacter] = useState<ICharacter | null>() // AI推荐的人设
  const [currentCharacter, setCurrentCharacter] = useState<ICharacter | null>() // 当前选择的人设
  const [showCharacterListPop, setShowCharacterListPop] = useState(false) // 是否显示人设列表弹窗
  const [showCharacterDetailPop, setShowCharacterDetailPop] = useState(false) // 是否显示人设详情弹窗
  const [currentCharacterDetail, setCurrentCharacterDetail] = useState<{
    character: ICharacter
    onlyShow: boolean
  } | null>() // 当前人设详情

  // 人设筛选配置列表
  const [characterFilterConfigList, setCharacterFilterConfigList] = useState<ICharacterFilter[]>([])
  // 已选的人设筛选项
  const [selectedCharacterFilterList, setSelectedCharacterFilterList] = useState<ISelectedCharacterFilter[]>([])

  // 清空人设列表/人设筛选
  const clearCharacterListPopData = () => {
    setCharacterList([])
    setCharacterFilterConfigList([])
    setSelectedCharacterFilterList([])
  }

  // 初始化人设设置
  const initCharacterSetting = () => {
    setShowCharacterSetting(true)
    setCharacterList([])
    setAiRecommendCharacter(null)
    setCurrentCharacter(null)
    setShowCharacterListPop(false)
    setShowCharacterDetailPop(false)
    setCurrentCharacterDetail(null)
    setCharacterFilterConfigList([])
    setSelectedCharacterFilterList([])
  }

  return {
    showcharacterSetting,
    setShowCharacterSetting,
    characterList,
    setCharacterList,
    aiRecommendCharacter,
    setAiRecommendCharacter,
    currentCharacter,
    setCurrentCharacter,
    showCharacterDetailPop,
    setShowCharacterDetailPop,
    showCharacterListPop,
    setShowCharacterListPop,
    characterFilterConfigList,
    setCharacterFilterConfigList,
    selectedCharacterFilterList,
    setSelectedCharacterFilterList,
    currentCharacterDetail,
    setCurrentCharacterDetail,
    clearCharacterListPopData,
    initCharacterSetting,
  }
}

export default useAICharacterModel
